/*
 * Estimated shipping day (Wyze Digital)
 *
 * Renders into any element with [data-delivery-estimate]. Config comes from
 * #delivery-estimate-config (snippets/delivery-estimate-config.liquid).
 *
 * Rules:
 * - Shipping days are Monday to Friday, excluding bank holidays and closure dates.
 * - Orders placed before the cut-off (UK time) on a shipping day ship that day, but only
 *   if same-day shipping is enabled for that weekday (e.g. Monday off: Monday still ships
 *   weekend orders, while Monday's own orders ship on Tuesday).
 * - Otherwise the order ships on the next shipping day.
 * - Bank holidays come from gov.uk (England and Wales), merged with the backup
 *   list in theme settings.
 */
(function () {
  var configEl = document.getElementById('delivery-estimate-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var FEED_URL = 'https://www.gov.uk/bank-holidays.json';
  var CACHE_KEY = 'wyzeBankHolidays';
  var CACHE_TTL = 24 * 60 * 60 * 1000;
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  var cutoffParts = String(config.cutoff || '14:00').split(':');
  var cutoffMinutes = parseInt(cutoffParts[0], 10) * 60 + parseInt(cutoffParts[1] || '0', 10);
  var sameDay = config.sameDay || [false, true, true, true, true, true, false];

  var bankHolidays = parseDateList(config.bankHolidays);
  var closures = parseDateList(config.closures);

  // Dates are handled as 'YYYY-MM-DD' keys on UTC midnight Date objects, so the
  // shopper's own timezone never shifts a day.
  function key(d) {
    return d.toISOString().slice(0, 10);
  }

  function addDays(d, n) {
    return new Date(d.getTime() + n * 86400000);
  }

  function toDate(y, m, d) {
    var date = new Date(Date.UTC(y, m - 1, d));
    return date.getUTCMonth() === m - 1 ? date : null;
  }

  function parseDate(str) {
    var m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (m) return toDate(+m[1], +m[2], +m[3]);
    m = str.match(/^(\d{1,2})[\/.](\d{1,2})[\/.](\d{4})$/);
    if (m) return toDate(+m[3], +m[2], +m[1]);
    return null;
  }

  // One date or range per line: "24/12/2026", "24/12/2026 - 01/01/2027", "2026-12-24 to 2027-01-01"
  function parseDateList(text) {
    var set = {};
    String(text || '').split(/\r?\n|,/).forEach(function (line) {
      line = line.split('#')[0].trim();
      if (!line) return;
      var parts = line.split(/\s+(?:-|–|to)\s+/i);
      var start = parseDate(parts[0].trim());
      var end = parts[1] ? parseDate(parts[1].trim()) : start;
      if (!start || !end || end < start) return;
      for (var d = start, i = 0; d <= end && i < 366; d = addDays(d, 1), i++) set[key(d)] = true;
    });
    return set;
  }

  function ukNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: toDate(+parts.year, +parts.month, +parts.day),
      minutes: +parts.hour * 60 + +parts.minute
    };
  }

  function isWeekday(d) {
    var day = d.getUTCDay();
    return day !== 0 && day !== 6;
  }

  function isShippingDay(d) {
    return isWeekday(d) && !bankHolidays[key(d)] && !closures[key(d)];
  }

  // The day an order placed on `date` at `minutes` past midnight (UK time) ships.
  function shipDateFor(date, minutes) {
    if (isShippingDay(date) && sameDay[date.getUTCDay()] && minutes < cutoffMinutes) return date;
    var d = addDays(date, 1);
    for (var i = 0; !isShippingDay(d) && i < 60; i++) d = addDays(d, 1);
    return d;
  }

  // Minutes until the ship date changes. It can only change at a cut-off or at midnight.
  function minutesUntilChange(date, minutes, ship) {
    for (var day = 0; day < 60; day++) {
      var candidates = day === 0 ? [cutoffMinutes, 1440] : [0, cutoffMinutes, 1440];
      for (var c = 0; c < candidates.length; c++) {
        var at = candidates[c];
        if (day === 0 && at <= minutes) continue;
        var d = addDays(date, day + Math.floor(at / 1440));
        if (key(shipDateFor(d, at % 1440)) !== key(ship)) return day * 1440 + at - minutes;
      }
    }
    return null;
  }

  function calculate() {
    var now = ukNow();
    var ship = shipDateFor(now.date, now.minutes);
    return {
      today: now.date,
      ship: ship,
      minutesLeft: minutesUntilChange(now.date, now.minutes, ship)
    };
  }

  function formatDate(d) {
    return DAY_NAMES[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTH_NAMES[d.getUTCMonth()];
  }

  function formatCountdown(mins) {
    mins = Math.max(1, mins);
    var h = Math.floor(mins / 60);
    var m = mins % 60;
    var out = [];
    if (h) out.push(h + (h === 1 ? ' hr' : ' hrs'));
    if (m) out.push(m + (m === 1 ? ' min' : ' mins'));
    return out.join(' ');
  }

  function formatCutoff() {
    var h = Math.floor(cutoffMinutes / 60);
    var m = cutoffMinutes % 60;
    return (h % 12 || 12) + (m ? ':' + (m < 10 ? '0' : '') + m : '') + (h >= 12 ? 'pm' : 'am');
  }

  // Weekday name within the next week (e.g. "Monday"), otherwise the full date.
  function formatShipDay(result) {
    var daysAhead = Math.round((result.ship - result.today) / 86400000);
    return daysAhead < 7 ? DAY_NAMES[result.ship.getUTCDay()] : formatDate(result.ship);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildMessage(result) {
    var daysAhead = Math.round((result.ship - result.today) / 86400000);
    var template = daysAhead === 0 ? config.messageSameDay
      : daysAhead === 1 ? config.messageTomorrow
      : config.messageLater;
    var values = {
      countdown: formatCountdown(result.minutesLeft || 1),
      cutoff: formatCutoff(),
      day: formatShipDay(result)
    };
    return escapeHtml(template).replace(/\[(countdown|cutoff|day)\]/g, function (_, name) {
      return '<strong>' + escapeHtml(values[name]) + '</strong>';
    });
  }

  function render(el) {
    var textEl = el.querySelector('.delivery-estimate__text');
    if (!textEl) return;
    if (el.getAttribute('data-out-of-stock') === 'true') {
      textEl.textContent = config.messageOutOfStock;
      el.classList.add('delivery-estimate--out-of-stock');
    } else {
      textEl.innerHTML = buildMessage(calculate());
    }
    el.hidden = false;
  }

  function renderAll() {
    var els = document.querySelectorAll('[data-delivery-estimate]');
    for (var i = 0; i < els.length; i++) render(els[i]);
  }

  function mergeHolidays(dates) {
    dates.forEach(function (d) { bankHolidays[d] = true; });
  }

  function loadFeed() {
    try {
      var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.time < CACHE_TTL && cached.dates) {
        mergeHolidays(cached.dates);
        return Promise.resolve();
      }
    } catch (e) {}

    if (!window.fetch) return Promise.resolve();
    return fetch(FEED_URL)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var dates = data['england-and-wales'].events.map(function (e) { return e.date; });
        mergeHolidays(dates);
        try {
          localStorage.setItem(CACHE_KEY, JSON.stringify({ time: Date.now(), dates: dates }));
        } catch (e) {}
      })
      .catch(function () {});
  }

  // The side cart swaps in basket HTML after every cart change, so watch for
  // new estimate elements rather than hooking into the cart code.
  function watch() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute('data-delivery-estimate')) render(node);
          var inner = node.querySelectorAll('[data-delivery-estimate]');
          for (var k = 0; k < inner.length; k++) render(inner[k]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    renderAll();
    loadFeed().then(renderAll);
    watch();
    setInterval(renderAll, 30000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) renderAll();
    });
  }

  window.deliveryEstimate = { calculate: calculate, renderAll: renderAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
